import script from "./GastronomyPoliciesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./GastronomyPoliciesSection.vue?vue&type=script&setup=true&lang=ts"

import "./GastronomyPoliciesSection.vue?vue&type=style&index=0&id=705255d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-705255d0"]])

export default __exports__